module.exports = __webpack_public_path__ + "static/media/DSC_9854.dcb0b3c8.jpg";